import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css"; // Shared legal/glass styling

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR */}
      <nav className="legal-nav">
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/icons/logo-512.png" className="nav-logo" alt="GrammAA" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      {/* ⭐ CONTENT */}
      <div className="legal-content glass-panel fade-in">
        <h1>Privacy Policy</h1>
        <p className="updated-date">Last updated: {new Date().getFullYear()}</p>

        <p>
          Your privacy is extremely important to us. This Privacy Policy explains how 
          <strong> GrammAA</strong> collects, uses, stores, and protects your data when 
          you use our AI-powered grammar and writing tools.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following information:</p>
        <ul>
          <li>Account information (email, login credentials)</li>
          <li>Text you input for grammar checking or rewriting</li>
          <li>Usage analytics to improve performance</li>
          <li>Payment details (processed securely via Razorpay)</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Your information is used to:</p>
        <ul>
          <li>Provide grammar checking and rewriting services</li>
          <li>Improve AI accuracy and overall user experience</li>
          <li>Communicate important updates or account alerts</li>
          <li>Process payments and maintain subscription access</li>
        </ul>

        <h2>3. Text Submitted for Checking</h2>
        <p>
          Any text you submit is processed securely. We <strong>do NOT</strong> 
          permanently store, share, or sell your writing. Temporary storage may occur 
          only for grammar processing and improving AI performance.
        </p>

        <h2>4. Cookies & Tracking</h2>
        <p>
          We use cookies for login sessions, analytics, and improving user experience. 
          You may disable cookies, but some features may stop working.
        </p>

        <h2>5. Payment Information</h2>
        <p>
          All payments are handled by secure third-party processors 
          (Razorpay). GrammAA does <strong>not</strong> store any card or banking data.
        </p>

        <h2>6. Data Security</h2>
        <p>
          We use encryption, secure servers, and strict access control to protect 
          your data. However, no online service can guarantee 100% security.
        </p>

        <h2>7. Sharing of Information</h2>
        <p>
          We never sell or share your personal data with third parties except:
        </p>
        <ul>
          <li>Service providers required to run the platform</li>
          <li>Payment processors (for subscriptions)</li>
          <li>Legal obligations if required by law</li>
        </ul>

        <h2>8. Account Deletion</h2>
        <p>
          You may request account deletion at any time by contacting us at  
          <strong> support@aiwebaa.com</strong>.  
          All associated data will be permanently removed.
        </p>

        <h2>9. Children's Privacy</h2>
        <p>
          GrammAA is not intended for users under the age of 13. We do not knowingly 
          collect data from children.
        </p>

        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Continued use of our 
          services means you accept the updated policy.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, contact us at:
          <br />
          <strong>support@aiwebaa.com</strong>
        </p>

        <br />
        <p>Thank you for trusting GrammAA with your writing.</p>
      </div>
    </div>
  );
};

export default Privacy;
